export const refactorQuestion = (response) => {
  try {
    if (Array.isArray(response) && response?.length) {
      return {
        status: true,
        data: {
          id: response[0]?.objectId,
          question: response[0]?.QuestionPtr,
        },
      };
    } else {
      return {
        status: false,
        error: response?.message,
      };
    }
  } catch (error) {
    return {
      status: false,
      error: error?.message,
    };
  }
};
